import { API } from '../config';
import M2Store from '../library/M2Store';
import axios from 'axios';


export default function M2Request(url, method = "GET", data = {}, headers = {}) {
    //формируем конфил для запроса
    let request_config = {
        url: API + url,
        method: method,
        data: data
    };

    //получаем токена
    let token = M2Store.get('access_token');
    console.log('send token: ', token);
    if(token && typeof token != "undefined") {
        headers['Authorization'] = 'Bearer ' + token;
        headers['TESTHEADER'] = 'Bearer ' + token;
    }

    console.log(headers);

    request_config['headers'] = headers;

    return axios(request_config);
}


// WEBPACK FOOTER //
// ./src/library/M2Request.js